import React ,  { Component }from "react";
import styles from "../../assets/css/modules/myprofile/contact-us-for-payment.css";
import Store from "../../content/Store";
import Accordion from "../shared/Accordion";
import Contentify from "../../content/Contentify";


export class ContactusForPayment extends Component {


  static content = Store.ContactusForPayment;


  render() {
    return (

    <div

      className={styles.CrestDownTime}
    > 
      <Accordion question={this.props.content?.title} answer={this.props.content?.body} ContactusForPayment={true}/> 
    </div>

  );
}
};

export default (Contentify(ContactusForPayment));